import { t } from "i18next";
import { InvoiceDetailsDto } from "../../../models/transportOrderInvoice/invoiceDetailsDto";
import { InvoiceRowType } from "../../../models/invoice/invoiceRowType";
import { ICustomerDetails } from "../../../models/customer/customerDetails";
import { Base } from "../../../framework/base";
import { InvoiceRowListItemDto } from "../../../models/transportOrderInvoice/invoiceRowListItemDto";
import { jspdfAutotableHelper } from "../../../framework/jspdfAutotableHelper";
import { pdfInvoice } from "./templates/pdfInvoice";

export const PrintTransportOrderInvoice = (
    invoice: InvoiceDetailsDto,
    customerDetails: ICustomerDetails,
    ownerName: string
) => {
    const dueDate = Base.dateToDateStr(new Date().addDays(14));
    const invoiceFileName = Base.dayjsToJsonDate(new Date()) + "_" +
        t("common.invoice.invoice") + "_" + invoice.invoiceNumber;

    const calculateTotalVat = (order: InvoiceRowListItemDto) => {
        return ((order.amount * order.unitPrice * order.vat) / 100).roundToDecimals(2);
    };

    const calculateTotalAmount = (order: InvoiceRowListItemDto) => {
        return order.amount * order.unitPrice + calculateTotalVat(order);
    };

    const products = [];
    invoice.transportOrderRows.forEach(function(orderRows) {
        orderRows.rows.forEach(function(orderRow) {
            if (orderRow.rowType === InvoiceRowType.Product) {
                products.push([
                    orderRow.description,
                    orderRow.amount,
                    orderRow.unitPrice.toLocaleFixed(2), // Unit price without VAT
                    calculateTotalVat(orderRow).toLocaleFixed(2),
                    calculateTotalAmount(orderRow).toLocaleFixed(2),
                    orderRow.vat.toLocaleString() + " %"
                ]);
            }
        });
    });

    const autoTableContent = pdfInvoice(
        invoice,
        products,
        customerDetails,
        ownerName,
        dueDate
    );

    return jspdfAutotableHelper(autoTableContent, invoiceFileName);
};
